// The one true class order for the whole app: school progression, JSS1 → SS3.
//
// Class lists reach the UI from several places — the teacher's saved profile
// (marketplace_plans.classes, stored in the order they happened to tap them),
// and DISTINCT queries over quiz_bank — none of which are ordered the way a
// teacher reads them. Sorting through here means a teacher always sees
// JSS1, JSS2, JSS3, SS1, SS2, SS3 instead of whatever order the data arrived in.
export const CLASS_ORDER = ["JSS1", "JSS2", "JSS3", "SS1", "SS2", "SS3"];

// Tolerant lookup: "ss 2", "SS2", "Ss2" all resolve to the same rank.
const rank = (value) => {
    const key = String(value || "").toUpperCase().replace(/[^A-Z0-9]/g, "");
    const index = CLASS_ORDER.indexOf(key);
    // Anything unrecognised (a custom class a teacher typed) sorts after the
    // known set rather than being dropped or jumping to the front.
    return index === -1 ? CLASS_ORDER.length : index;
};

// Sort a list of class names into school order. Returns a new array; unknown
// values keep their relative order at the end, alphabetically.
export const sortClasses = (classes = []) =>
    [...classes].sort((a, b) => {
        const diff = rank(a) - rank(b);
        return diff !== 0 ? diff : String(a).localeCompare(String(b));
    });
